import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSnackBar, MatCheckboxChange } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TransactionInvoiceService } from 'src/app/pages/transaction/services/transaction-invoice.service';
import { TransactionProfileService } from 'src/app/pages/transaction/services/transaction-profile.service';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { CostFormService } from '../../services/cost-form.service';
import { MultiLanguageService } from '../../services/multi-language.service';
import { ProcessService } from '../../services/process.service';
import { FineService } from 'src/app/pages/transaction-admin/services/fine.service';
import { DynamicFormService } from '../../services/dynamic-form.service';
import { BaseDynamicForm } from '../../services/base-dynamic-form';
import { TransactionRequirementService } from 'src/app/pages/transaction/services/transaction-requirement.service';
import { DialogYesNoComponent } from '../dialog-yes-no/dialog-yes-no.component';


@Component({
  selector: 'prgov-infraction-detail-modal',
  templateUrl: './infraction-detail-modal.component.html',
  styleUrls: ['./infraction-detail-modal.component.scss']
})
export class InfractionDetailModalComponent extends BaseDynamicForm
  implements OnInit {

  ELEMENT_DATA: any[];
   displayedColumns: string[] = [
    'InfractionCategoryName',
    'Total',
    'Checked',
  ];
  
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  note;
  infractionDetail: any[] = [];
  marbeteCost: any;
  initialPayment: any;
  isLoadingFine: boolean = false;

  showInitialPaymentAmount = false;

  constructor(
    protected translate: TranslateService,
    public infractionDetailService: FineService,
    public transactionInvoiceService: TransactionInvoiceService,
    public transactionService: TransactionService,
    public route: ActivatedRoute,
    public router: Router,
    public processService: ProcessService,
    public multiLanguageService: MultiLanguageService,
    public transactionProfileService: TransactionProfileService,
    public costFormService: CostFormService,
    public dialogRef: MatDialogRef<InfractionDetailModalComponent>,
    public dynamicFormService: DynamicFormService,
    private matSnackBar: MatSnackBar,
    public transactionRequirementService: TransactionRequirementService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
    // Data del modal
    console.log('datamodal', data)
    this.id = data.Id;
  }

  ngOnInit() {
    this.refreshLanguage();

   

    this.infractionDetailService.getById(this.id).then((data: any) => {
        if (data.length > 0) {

          this.transactionRequirementService.getProponentRequirements(this.transactionService.itemToEdit.Id).then((dataRequirement: any) => {
            const requirement = dataRequirement.find(item => item.ModuleName === "FormularioDeRevisionDeBoleto");
            let updatedData = [];
            if (requirement.ProcessJson) {
 
                const { data: dataJson } = JSON.parse(requirement.ProcessJson);
                console.log('dataJson',dataJson)
                console.log('data',data)
                if (dataJson[0] && 'FineId' in dataJson[0]) {
                  if(this.id == dataJson[0].FineId){
                    this.note = dataJson[0].Note
                  }
                }

                const checkedMap = dataJson.reduce((acc, item) => {
                  if (item.Id && item.Checked !== undefined) {
                      acc[item.Id] = item.Checked;
                  }
                  return acc;
                }, {});

                updatedData = data.map(item => ({
                  ...item,
                  Checked: checkedMap[item.Id] || false
                }));

                console.log('updatedData',updatedData);

            }

            
          
            this.dataSource = new MatTableDataSource<any>(updatedData.length>0 ? updatedData : data);
            
      
          }); 

        
        } else {
            this.dataSource = new MatTableDataSource<any>([]);
        }

        console.log('this.dynamicFormService.requirement', this.dynamicFormService.requirement);

        /* if (this.dynamicFormService.requirement) {
            this.prepareFormFromData(this.formQty, this.dynamicFormService.requirement);
        } */
    });
}



  backToTransaction() {
    this.router.navigate([`/transactions/edit/${this.transactionService.itemToEdit.Id}`]);
  }

  gotoUrl(id) {
    let url = 'transactions';

    if (id) {
      url = url + '/edit/' + id;
    }

    this.router.navigate([url]);
  }

 

  do() {
    this.translate.use('es');
  }


  checkAlegato(event: MatCheckboxChange, element: any) {

     element.Checked = event.checked;
/* 
     this.dataSource.data.forEach((item: any) => {
         if (item !== element) {
             item.Checked = false;
         }
     }); */
 
  
  }

  save(isComplete){
      this.isLoadingFine = true;
      this.formData = [];

      this.formData.push({
          Note: this.note,
          FineId: this.id
      })
                  
      for (let i = 0; i < this.dataSource.data.length; i++) {
              const element = this.dataSource.data[i];
              if(element.Checked){
                    this.formData.push({
                    Id: element.Id,
                    InfractionCategoryName: element.InfractionCategoryName,
                    Description: element.Description,
                    Total: element.TotalAmount,
                    Checked: element.Checked,
                    NroBoleto: element.ExternalInfractionId
                    });
              }
      }
                              
      this.formData = {
          data: this.formData 
      };
                  
      this.translate.get(['message.savedSuccess', 'message.done'])
              .subscribe(translations => {
                  if(this.isSaving()) return;
                  
                      this.dynamicFormService.isComplete = isComplete;
                  
                      this.startSaving("saving");
                  
                      this.dynamicFormService
                      .save(this.formData)
                      .then(()=>{
                          this.isLoadingFine = false;
                          this.stopSaving();
                          this.dynamicFormService.formCommunicator.next("stop-saving");
                          this.transactionService.transactionRefresher.next();
                  
                          if(isComplete){
                            console.log("show snackbar")
                          
                            let snackBarRef = this.matSnackBar.open(translations['message.savedSuccess'], translations['message.done'],  {
                              duration: 1000
                            });
                            console.log('this.formData', this.formData)
                            this.dialogRef.close(this.formData);
                          }
                      });
      });
  
  }



}
